export const GET_REPORT_FLOWS = `
  query GetReportFlows($where: report_flows_bool_exp = {}) {
    report_flows(where: $where, order_by: { created_at: desc }) {
      id
      flow_title
      flow_description
      job_types
      source_type
      filter_config
      flow_type
      start_date
      end_date
      report_type_ids
      job_statuses
      is_active
      is_archived
      archived_at
      archived_by
      company_id
      created_by
      created_at
      updated_at
      archived_by_user {
        id
        first_name
        last_name
      }
      report_flow_columns(order_by: { column_order: asc }) {
        id
        flow_id
        column_title
        column_order
        column_color
        is_completion_column
        column_action
        created_at
        updated_at
      }
      report_flow_items(where: { is_archived: { _eq: false } }) {
        id
        report_id
        job {
          id
          job_reports
        }
      }
    }
  }
`;

export const GET_REPORT_FLOW_DETAIL = `
  query GetReportFlowDetail($id: Int!) {
    report_flows_by_pk(id: $id) {
      id
      flow_title
      flow_description
      job_types
      source_type
      filter_config
      flow_type
      start_date
      end_date
      report_type_ids
      job_statuses
      is_active
      company_id
      created_by
      created_at
      updated_at
      report_flow_columns(order_by: { column_order: asc }) {
        id
        flow_id
        column_title
        column_order
        column_color
        is_completion_column
        column_action
        created_at
        updated_at
        report_flow_items(
          where: { is_archived: { _eq: false } }
          order_by: { item_order: asc }
        ) {
          id
          flow_id
          column_id
          job_id
          report_id
          item_order
          completion_date
          submission_date
          is_archived

          company_id
          created_by
          created_at
          updated_at
          job {
            id
            job_title
            job_type
            job_type_id
            job_type_rel { id name is_project_based }
            job_status
            firm_id
            firm_short_name
            project_number
            job_reports
            company_id
            updated_at
            job_details(order_by: { created_at: desc }) {
              id
              detail_data
              created_at
            }
            contract {
              id
              contract_signing_date
              updated_at
              firm {
                id
                firm_name
                firm_short_name
              }
            }
            job_assignment {
              id
              technical_user {
                id
                first_name
                last_name
              }
              financial_user {
                id
                first_name
                last_name
              }
              technical_team {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ARCHIVED_FLOW_ITEMS = `
  query GetArchivedFlowItems($flow_id: Int!) {
    report_flow_items(
      where: { flow_id: { _eq: $flow_id }, is_archived: { _eq: true } }
      order_by: { updated_at: desc }
    ) {
      id
      flow_id
      column_id
      job_id
      report_id
      item_order
      completion_date
      submission_date
      is_archived
      company_id
      created_by
      created_at
      updated_at
      job {
        id
        job_title
        job_type
        job_type_id
        job_type_rel { id name is_project_based }
        job_status
        firm_id
        firm_short_name
        project_number
        job_reports
        company_id
        contract {
          id
          firm {
            id
            firm_name
            firm_short_name
          }
        }
      }
    }
  }
`;

export const GET_ACTIVE_REPORTS = `
  query GetActiveReports($where: jobs_bool_exp = {}, $today: date!) {
    jobs(
      where: {
        _and: [
          $where,
          { job_reports: { _is_null: false } },
          { job_reports: { _cast: { String: { _neq: "[]" } } } }
        ]
      }
      order_by: { created_at: desc }
    ) {
      id
      job_title
      job_type
      job_type_id
      job_type_rel { id name is_project_based }
      job_status
      firm_id
      firm_short_name
      job_reports
      company_id
      project_number
      contract {
        id
        firm {
          id
          firm_name
        }
      }
    }
  }
`;

export const GET_ACTIVE_REPORTS_BY_DATE = `
  query GetActiveReportsByDate($where: jobs_bool_exp = {}) {
    jobs(
      where: {
        _and: [
          $where,
          { job_reports: { _is_null: false } }
        ]
      }
      order_by: { created_at: desc }
    ) {
      id
      job_title
      job_type
      job_type_id
      job_type_rel { id name is_project_based }
      job_status
      firm_id
      firm_short_name
      job_reports
      company_id
      project_number
      contract {
        id
        firm {
          id
          firm_name
        }
      }
      job_assignment {
        id
        technical_user {
          id
          first_name
          last_name
        }
        financial_user {
          id
          first_name
          last_name
        }
        technical_team {
          id
          name
        }
      }
    }
    report_flow_items(where: { is_archived: { _eq: false } }) {
      job_id
      report_id
    }
    report_financial_requests(where: { status: { _eq: "pending" } }) {
      job_id
      report_id
    }
  }
`;

export const GET_REPORT_FLOW_ITEMS_BY_FLOW = `
  query GetReportFlowItemsByFlow($flow_id: Int!, $where: report_flow_items_bool_exp = {}) {
    report_flow_items(
      where: {
        _and: [
          { flow_id: { _eq: $flow_id } },
          $where
        ]
      }
      order_by: [{ column_id: asc }, { item_order: asc }]
    ) {
      id
      flow_id
      column_id
      job_id
      report_id
      item_order
      completion_date
      submission_date
      is_archived
      company_id
      created_by
      created_at
      updated_at
      job {
        id
        job_title
        job_type
        job_type_id
        job_type_rel { id name is_project_based }
        job_status
        firm_id
        firm_short_name
        project_number
        job_reports
        company_id
        contract {
          id
          firm {
            id
            firm_name
            firm_short_name
          }
        }
      }
    }
  }
`;

export const GET_JOB_REPORTS_FOR_ID = `
  query GetJobReportsForId($id: uuid!) {
    jobs_by_pk(id: $id) {
      id
      job_reports
    }
  }
`;

// JOB_LIST friendly: fetches jobs WITHOUT requiring job_reports.
// Used to populate JOB_LIST flows where every job (regardless of whether
// it has reports defined) becomes a flow item with report_id = null.
export const GET_JOBS_FOR_FLOW_POPULATION = `
  query GetJobsForFlowPopulation($where: jobs_bool_exp = {}) {
    jobs(where: $where, order_by: { created_at: desc }) {
      id
      company_id
      job_type
      job_type_id
      # Dinamik is turlerine gecisten sonra jobs.job_type (legacy text) yeni
      # isletde NULL kaliyor; gercek deger bu iliski uzerinden gelir.
      # matchFlowScope job_type_rel.name fallback'ini okur — alan secilmezse
      # fallback olu kod olur ve yeni isler akisa hic girmez (bkz. cron'daki
      # COALESCE(NULLIF(j.job_type,''), jt.name)).
      job_type_rel {
        id
        name
      }
      job_title
      job_status
      firm_id
      firm_short_name
      project_number
      created_at
      contract {
        id
        firm {
          id
          firm_name
        }
      }
    }
    # is_archived filtresi YOK: arsivlenmis item da dedupe setine girmeli.
    # Aksi halde arsivlenen bir is yeniden insert edilmeye calisilir ve
    # UNIQUE (flow_id, job_id, report_id) ihlali tum bulk insert'i dusurur.
    report_flow_items {
      job_id
      report_id
      flow_id
    }
  }
`;

